/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_User_Api_Key_Source_Teams_BotInputs */



/**
* | output |
* | --- |
* | "Teams Bot" |
*
* @param {Profile_Security_User_Api_Key_Source_Teams_BotInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_user_api_key_source_teams_bot = /** @type {((inputs?: Profile_Security_User_Api_Key_Source_Teams_BotInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_User_Api_Key_Source_Teams_BotInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Teams Bot")
	return /** @type {LocalizedString} */ ("Teams Bot")
});